export default "__VITE_ASSET__e5o48CfG__"